/* eslint-disable react-hooks/exhaustive-deps */
/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-06-10 11:39:10
 *
 *******************************************************/
// @flow
import React, { useState } from 'react';
import { Collapsible } from '@shopify/polaris';
import { TURBO_LANDING_PAGE_DATA } from 'src/constants/landing-page';
import collapseIcon from 'src/assets/images/landing-page/turbo/collapse.svg';
import expandIcon from 'src/assets/images/landing-page/turbo/expand.svg';

const FaqList = ({ i18n }) => {
  const data = TURBO_LANDING_PAGE_DATA(i18n).Faqs;

  const [indexOpen, setIndexOpen] = useState(0);
  return (
    <div className="Faq-list list">
      {data.map((item, index) => {
        const { question, answer } = item;
        return (
          <FaqItem
            key={index}
            question={question}
            answer={answer}
            index={index}
            indexOpen={indexOpen}
            onCickItem={index => setIndexOpen(index)}
          />
        );
      })}
    </div>
  );
};
const FaqItem = ({ question, answer, indexOpen, index, onCickItem }) => {
  const isCurrentOpen = index === indexOpen;

  return (
    <div className="parallax faq-item">
      <div className="activator" onClick={() => onCickItem(isCurrentOpen ? null : index)}>
        <div className="question">{question}</div>
        <div className="icon">
          <img src={isCurrentOpen ? collapseIcon : expandIcon} alt="" />
        </div>
      </div>
      <Collapsible
        open={indexOpen === index}
        transition={{ duration: '500ms', timingFunction: 'ease-in-out' }}>
        <div className="content">{answer}</div>
      </Collapsible>
    </div>
  );
};

export default FaqList;
